import React from 'react'
import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  VStack,
  Icon,
} from '@chakra-ui/react'
import {
  FaUsers,
  FaMusic,
  FaCalendarAlt,
  FaGlobe,
  FaFileAlt,
  FaUserShield,
} from 'react-icons/fa'

const FeatureCard = ({ icon, title, description }) => (
  <VStack gap={4} align="flex-start" textAlign="left" p={{ base: 2, md: 4 }}>
    <Box
      w={12}
      h={12}
      rounded="xl"
      bg="purple.100"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Icon as={icon} boxSize={5} color="purple.600" />
    </Box>
    <Heading size="md" color="gray.800">
      {title}
    </Heading>
    <Text color="gray.600" lineHeight="tall" fontSize="md">
      {description}
    </Text>
  </VStack>
)

const Features = () => {
  const features = [
    {
      icon: FaUsers,
      title: 'Plantilla y formaciones',
      description: 'Músicos, voces e instrumentos listos para pasar lista en ensayos y actuaciones.',
    },
    {
      icon: FaMusic,
      title: 'Archivo Musical',
      description: 'Sube partituras; Cadencya las organiza por obra, carpeta y voz.',
    },
    {
      icon: FaCalendarAlt,
      title: 'Ensayos y actuaciones',
      description: 'Programa, comparte asistencia y ten el calendario de la agrupación a mano.',
    },
    {
      icon: FaGlobe,
      title: 'Tu Web',
      description: 'Tu propia frontpage en la misma herramienta. Enseña al mundo quiénes sois.',
    },
    {
      icon: FaFileAlt,
      title: 'Documentos',
      description: 'Tablón de documentos interno. Perfecto para tus comunicaciones al grupo.',
    },
    {
      icon: FaUserShield,
      title: 'Permisos',
      description: 'Colaboradores con acceso concreto a archivo, músicos, ensayos u otras áreas.',
    },
  ]

  return (
    <Box bg="gray.50" py={{ base: 16, md: 24 }} data-landing="features">
      <Container maxW="7xl">
        <VStack gap={{ base: 12, md: 16 }}>
          <VStack gap={4} textAlign="center">
            <Heading
              as="h2"
              fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}
              fontWeight="800"
              color="gray.800"
            >
              Todo lo que necesitas
            </Heading>
            <Text fontSize={{ base: 'lg', md: 'xl' }} color="gray.600" maxW="2xl">
              Una plataforma simple pero completa para el día a día de la banda.
            </Text>
          </VStack>

          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap={{ base: 8, md: 10 }} w="full">
            {features.map((feature) => (
              <FeatureCard
                key={feature.title}
                icon={feature.icon}
                title={feature.title}
                description={feature.description}
              />
            ))}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>
  )
}

export default Features
